import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { getLocaleString } from "lib/localization/vendor";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";

export default function StyleFeatureLinearRing(feature:Feature<Geometry>) {
	const colorHex = "#000000";
  return [
	new Style({
	  stroke: new Stroke({
		color: colorHex,
		width: 3
	  }),
	  fill: new Fill({
		color: "rgba(0, 0, 0, 0.2)",
	  }),
	  image: new CircleStyle({
		radius: 6,
		fill: new Fill({
		  color: colorHex,
		}),
		stroke: new Stroke({
		  color: "black",
		  width: 1,
		}),
	  })
	}),
  ];
}